import { IFunctionComponent } from '@omaze/app';
import React, { ReactElement } from 'react';

import { nonProfitFeatureNamespace } from '../../../../../../NonProfitFeature.namespace';

import { displayName, IMPACT_MESSAGE_QA } from './ImpactMessage.qa';
import styles from './ImpactMessage.styles.css';

export interface IImpactMessageProps {
    message: string;
}

export const ImpactMessage: IFunctionComponent<IImpactMessageProps> = nonProfitFeatureNamespace.createComponent(
    displayName,
    (props: IImpactMessageProps): ReactElement => {
        const { message }: IImpactMessageProps = props;

        return (
            <div className="mt-4 py-3 px-5 text-center w-screen bg-navy-50 lg:py-3 lg:w-full lg:bg-none lg:flex lg:flex-col lg:justify-center lg:mt-0" data-testid={IMPACT_MESSAGE_QA.CONTAINER}>
                <h6 className={`${styles.header} my-0 mx-auto font-gellix not-italic text-base text-teal-800 font-bold`}>This Omaze experience can:</h6>
                <p className={`${styles.content} font-gellix not-italic text-gray-900 text-med mt-1 mb-0 ml-auto mr-auto font-bold`}>{message}</p>
            </div>
        );
    }
);
